<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyWork"
        @search="search"
      ></ly-search
    ></report-top>
    <selectTool ref="selectTool"
      ><template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun">查询</Button
        ><Button @click="openAdd" type="primary" class="chaxun"
          >新增</Button
        ></template
      ></selectTool
    >

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      :title="isAdd ? '新增规则' : '编辑规则'"
      width="700"
      ref="formModel"
    >
      <Alert type="info" showIcon slot="quyu"
        >按区域需要完善始发地，目的地</Alert
      >
      <Alert type="info" showIcon slot="geren"
        >按个人需要完善始发地，目的地</Alert
      >
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
  </div>
</template>
<script>
var categorys = [];
var type = [
  { id: 0, name: "按区域" },
  { id: 1, name: "按个人" },
];
export default {
  data() {
    return {
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
          sort: 0,
        },
        /*   {
          title: "规则内容",
          key: "rule_regex",
          type: "Input",
          selectItems: type,
          sort: 5,
        }, */

        {
          title: "操作",
          slot: "action",
          sort: 200,
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        name: "",
        price: 0,
        type: 0,
        subsidy: 0,
        driver: "",
        rule: {
          regex: "",
          addressS: "",
          addressD: "",
          adcodeS:"",
          adcodeD:""
        },
        remark: "",
        rule_regex: "",
        rule_addressS: "",
        rule_addressD: "",
        rule_adcodeS:"",
        rule_adcodeD:""
      },
      forms: [
        {
          title: "规则名称",
          key: "name",
          type: "Input",
          required: true,
        },
        {
          title: "计费方式",
          key: "type",
          key2: "type2",
          type: "Select",
          selectType: "obj",
          selectItems: type,
          required: true,
        },
        {
          title: "每趟费用",
          key: "price",
          type: "InputNumber",
          selectItems: type,
        },
         {
          title: "备注",
          key: "remark",
          type: "Input",
          selectItems: type,
        },
        {
          title: "按区域",
          hideLabel: true,
          noTable: true,
          slotForm: "quyu",
          span: 24,
        },
        {
          title: "始发地",
          key: "rule_addressS",
          type: "city", 
          adcode: "rule_adcodeS",
          noTable: true,
          //selectItems: this.lydic.getA("addressPrice"),
        },
        {
          title: "目的地",
          key: "rule_addressD",
          type: "city", 
          adcode: "rule_adcodeD",
          noTable: true,
          //selectItems: this.lydic.getA("addressPrice"),
        },
        {
          title: "个人",
          hideLabel: true,
          noTable: true,
          slotForm: "geren",
          span: 24,
        },
        {
          title: "司机姓名",
          //key4: "driverAccount",
          key1: "driver",
          clearable: true,
          required: false,
          type: "selectUser",
          keyword: "司机",
        },
        
        {
          title: "费用补贴",
          key: "subsidy",
          type: "InputNumber",
          required: true,
        },

       
      ],
      searchItem: {
        keyWork: "",
        pageNumber: 1,
        pageSize: 50,
      },
      searchForms: [
        /* {
          title: "类型分类",
          key: "categorys",
          type: "Select",
          selectItems: categorys,
        },
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          type: "lyyymmdd",
          times: "2,0",
        }, */
      ],
      total: 0,
      categorys: [],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-fms/tripCostRule/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        console.log(data);
        for (let i = 0; i < data.length; i++) {
          data[i].type2 = type[data[i].type].name;

          //data[i].rule_addressS = data[i].rule.addressS;
          //data[i].rule_addressD = data[i].rule.addressD;
          var t = data[i].rule;
          for (const j in t) {
            data[i]["rule_" + j] = t == null ? "" : t[j];
          }
          //this.objto(data[i].rule);
        }
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.toObj();

      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-fms/tripCostRule/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-fms/tripCostRule/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-tms-server-fms/tripCostRule/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },

    toObj() {
      var t = this.item;
      for (const i in t) {
        if (i.indexOf("_") != -1) {
          var m = i.split("_");
          t[m[0]][m[1]] = t[i];
        }
      }
    },
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      delete this.item._index;
      delete this.item._rowKey;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },

    selectCartype(x) {
      this.selectIcon = x.value;
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
  },
  mounted() {
    var config = {
      min: 100,
      max: 300,
    };
    this.columns = this.utils.cols(this.forms, this.columns);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/wuliu/caiwu/sijijifeiguize.vue